import React from "react";
import axios from "../../../containers/api";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import { Link } from "react-router-dom";
import polyline from "google-polyline";
import { Table } from "../../../components/table/Table";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {
  getkalas,
  getLoaderTypes,
  getBastebandys,
  showCatchError,
  toEnglishNumbers,
  toCurrency,
  getDurationHour,
  getDayBefore,
  GetDistinctLoaderTypes,
} from "../../../helpers/Utils";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import {
  Button,
  Card,
  CardBody,
  Collapse,
  Input,
  ModalBody,
  Modal,
  ModalHeader,
  Row,
  Alert,
  InputGroupAddon,
  InputGroup,
  FormGroup,
  Label,
  CustomInput,
  ModalFooter,
} from "reactstrap";
import Config from "../../../constants/config";
import "../../../assets/css/sass/maps.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import AddCustomerModal from "../../info-base/customer/components/AddCustomerModal";
import EditCustomer from "../../info-base/customer/components/EditCustomer";
import Customer from "../../info-base/customer/Customer";

class AddCargo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      specificLoad: false,
      customer: [],
      searchValue: "",
      sender: null,
      receiver: null,
      cargoRange: 45,
      kalaValue: null,
      Tel: "",
      kala: null,
      Bastebandy: null,
      freighterNumber: 1,
      bastebandyNumber: 1,
      kalaWeight: null,
      cargoRent: null,
      description: null,
      selectedLoaderTypes: [],
      selectedLoaderTypeCode: null,
      cargoSource: "",
      cargoDestination: "",
      errors: [],
      errorInputs: [],

      selectedkalas: [],
      Bastebandys: [],
      kalas: [],
      loaderTypes: [],
      loaderTypeCodes: [],
    };
  }

  componentDidMount() {
    try {
      this.getBastebandysApi().then((r) => console.log(r));
    } catch (err) {
      console.log(err);
    }
    try {
      this.getkalasApi().then((r) => console.log(r));
    } catch (err) {
      console.log(err);
    }
    try {
      this.GetDistinctLoaderTypes().then((r) => console.log(r));
    } catch (err) {
      console.log(err);
    }
  }

  async getBastebandysApi() {
    try {
      await getBastebandys().then((res) =>
        this.setState({ Bastebandys: res.data }),
      );
    } catch (err) {
      this.props.showAlert(showCatchError(err), "error");
    }
  }
  async getkalasApi() {
    try {
      await getkalas().then((res) => this.setState({ kalas: res.data }));
    } catch (err) {
      this.props.showAlert(showCatchError(err), "error");
    }
  }
  async getLoaderTypesApi() {
    try {
      await getLoaderTypes().then((res) =>
        this.setState({ loaderTypes: res.data }),
      );
    } catch (err) {
      this.props.showAlert(showCatchError(err), "error");
    }
  }
  async GetDistinctLoaderTypes() {
    try {
      await GetDistinctLoaderTypes().then((res) => {
        this.setState({ loaderTypeCodes: res.data });
      });
    } catch (err) {
      this.props.showAlert(showCatchError(err), "error");
    }
  }
  getLoaderTypesByCode = (Code) => {
    axios
      .get("/api/v1/loader-types/GetLoaderTypeByCode?Code=" + Code)
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ loaderTypes: res.data.data });
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
        this.props.showAlert(showCatchError(error), "error");
      });
  };

  selectHandleChange = (event, value, name) => {
    if (name === "selectedLoaderTypeCode") {
      if (value !== undefined && value !== null) {
        this.setState({ selectedLoaderTypes: [] }, () =>
          this.getLoaderTypesByCode(value.typeCode),
        );
      } else {
        this.setState({
          selectedLoaderTypes: [],
        });
      }
    }
    this.setState({ [name]: value });
  };

  validateInputData = () => {
    this.props.closeSweetAlert();
    let error = [];
    let errorInputs = [];

    if (this.state.Bastebandy === null || this.state.Bastebandy === "") {
      error.push("انتخاب  بسته‌بندی الزامی میباشد.");
      errorInputs.push("Bastebandy");
    }

    if (
      (this.state.bastebandyNumber === null ||
        toEnglishNumbers(this.state.bastebandyNumber) === 0 ||
        this.state.bastebandyNumber === "" ||
        this.state.bastebandyNumber === undefined ||
        toEnglishNumbers(this.state.bastebandyNumber) === "0") &&
      this.state.Bastebandy &&
      this.state.Bastebandy.BastebandyID !== 1
    ) {
      error.push("وارد كردن تعداد بسته الزامی میباشد");
      errorInputs.push("bastebandyNumber");
    }

    if (this.state.selectedLoaderTypes.length < 1) {
      error.push("انتخاب نوع کشنده الزامی میباشد");
      errorInputs.push("selectedLoaderTypes");
    }

    if (!Number(toEnglishNumbers(this.state.freighterNumber))) {
      error.push("وارد كردن تعداد کامیون الزامی میباشد");
      errorInputs.push("freighterNumber");
    }

    if (
      this.state.Tel === null ||
      this.state.Tel === "" ||
      this.state.Tel === ""
    ) {
      error.push("وارد كردن شماره تماس الزامي میباشد");
      errorInputs.push("Tel");
    }
    if (
      this.state.kalaWeight === null ||
      toEnglishNumbers(this.state.kalaWeight) === 0
    ) {
      error.push("وارد كردن وزن محموله الزامی میباشد");
      errorInputs.push("kalaWeight");
    }
    if (
      this.state.cargoRent === null ||
      this.state.cargoRent === "" ||
      toEnglishNumbers(this.state.cargoRent) === 0
    ) {
      error.push("وارد كردن کرایه الزامی میباشد");
      errorInputs.push("cargoRent");
    }

    if (this.state.kala === null || this.state.kala === "") {
      error.push("انتخاب نوع محموله الزامی میباشد.");
      errorInputs.push("kala");
    }

    if (
      this.state.cargoSource === null ||
      this.state.cargoSource === "" ||
      this.state.cargoSource === undefined ||
      this.state.cargoDestination === null ||
      this.state.cargoDestination === undefined ||
      this.state.cargoDestination === ""
    ) {
      error.push("وارد كردن مبدا و مقصد الزامی میباشد");
      errorInputs.push("cargoSource");
    }

    this.setState({ errors: error, errorInputs: errorInputs });
    if (error.length === 0) {
      this.submitForm();
    } else {
      this.props.showAlert(
        "لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!",
        "error",
      );
    }
  };
  submitForm = () => {
    let loaderTypeIds = [];

    for (let i = 0; i < this.state.selectedLoaderTypes.length; i++) {
      loaderTypeIds.push(this.state.selectedLoaderTypes[i].id);
    }

    const model = {
      Tel: this.state.Tel,
      CargoSource: this.state.cargoSource,
      CargoDestination: this.state.cargoDestination,
      CargoRent: toEnglishNumbers(this.state.cargoRent),
      KalaWeight: toEnglishNumbers(this.state.kalaWeight),
      LoaderTypeIds: loaderTypeIds,
      KalaId: this.state.kala.id,
      BastebandyId: this.state.Bastebandy.id,
      FreighterNumber: toEnglishNumbers(this.state.freighterNumber),
      Description: toEnglishNumbers(this.state.description),
    };

    this.props.showSpinner();
    console.log(model);
    axios
      .post("/api/v1/cargos/AddCargo", model)
      .then((res) => {
        this.props.hideSpinner();
        if (res.status === 200) {
          this.props.showAlert(res.data.message, "success");
        }
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
      });
  };

  reset = () => {
    this.props.closeSweetAlert();
    this.setState({
      searchValue: "",
      sender: null,
      senderAddress: null,
      receiver: null,
      receiverAddress: null,
      loadHall: null,
      cargoRange: 45,
      kalaValue: null,
      Tel: "",
      kala: null,
      Bastebandy: null,
      freighterNumber: null,
      bastebandyNumber: 1,
      kalaWeight: null,
      cargoRent: null,
      description: null,
      selectedLoaderTypes: [],
      cargoSource: "",
      cargoDestination: "",
      cargoDistance: "",
      cargoDuration: "",
      cargoSourceLat: "",
      cargoSourceLong: "",
      cargoDestinationLat: "",
      cargoDestinationLong: "",
      isPishElamBar: false,
      pishElamBarName: "",
      isLoadHall: true,
      errors: [],
      FutureDate: utils("fa").getToday(),
      FutureMinute: "00",
      FutureHour: "00",
    });
  };

  render() {
    return (
      <>
        <Row>
          <Colxx xxs="12">
            <h3> اعلام بار جدید</h3>
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Row className="mb-3">
          <Colxx xxs="12">
            <Card>
              <CardBody className="d-flex flex-column">
                <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* تلفن جهت هماهنگی :</Label>
                    <Input
                      value={this.state.Tel}
                      onChange={(e) => this.setState({ Tel: e.target.value })}
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* محل بارگیری :</Label>
                    <Input
                      value={this.state.cargoSource}
                      innerRef={this.cargoSource}
                      placeholder=" "
                      onChange={(e) =>
                        this.setState({ cargoSource: e.target.value })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* محل تخلیه :</Label>
                    <Input
                      value={this.state.cargoDestination}
                      innerRef={this.cargoDestination}
                      placeholder=" "
                      onChange={(e) =>
                        this.setState({ cargoDestination: e.target.value })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* کرایه صافی (تومان) :</Label>
                    <Input
                      value={toCurrency(this.state.cargoRent)}
                      maxLength={14}
                      onChange={(e) =>
                        this.setState({
                          cargoRent: e.target.value.replace(/[^0-9۰-۹]/g, ""),
                        })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* وزن (تن) :</Label>
                    <Input
                      value={toCurrency(this.state.kalaWeight)}
                      onChange={(e) =>
                        this.setState({
                          kalaWeight: e.target.value.replace(/[^0-9۰-۹]/g, ""),
                        })
                      }
                    />
                  </FormGroup>
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row className="mb-3">
          <Colxx xxs="12">
            <Card>
              <CardBody className="d-flex flex-column">
                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* ناوگان :</Label>
                    <Autocomplete
                      clearText={"حذف"}
                      closeText={"بستن"}
                      noOptionsText={"در حال دریافت اطلاعات.."}
                      openText={"باز کردن"}
                      className="react-select__control"
                      id="selectedLoaderTypeCode"
                      options={this.state.loaderTypeCodes}
                      getOptionLabel={(option) => option.loaderTypeName}
                      value={this.state.selectedLoaderTypeCode}
                      onChange={(e, v) =>
                        this.selectHandleChange(e, v, "selectedLoaderTypeCode")
                      }
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* بارگیر :</Label>
                    <Autocomplete
                      multiple
                      clearText={"حذف"}
                      closeText={"بستن"}
                      noOptionsText={"در حال دریافت اطلاعات.."}
                      openText={"باز کردن"}
                      className="react-select__control"
                      id="selectedLoaderTypes"
                      options={this.state.loaderTypes}
                      groupBy={(option) => option.loaderTypeName}
                      getOptionLabel={(option) =>
                        option.loaderTypeName + " " + option.loaderTypeDesc
                      }
                      value={this.state.selectedLoaderTypes}
                      onChange={(e, v) =>
                        this.selectHandleChange(e, v, "selectedLoaderTypes")
                      }
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* کالا :</Label>
                    <Autocomplete
                      clearText={"حذف"}
                      closeText={"بستن"}
                      noOptionsText={"در حال دریافت اطلاعات.."}
                      openText={"باز کردن"}
                      className="react-select__control"
                      id="kala"
                      groupBy={(option) => option.kalaDesc}
                      options={this.state.kalas}
                      getOptionLabel={(option) =>
                        option.kalaDesc + "-" + option.logesticDesc
                      }
                      value={this.state.kala}
                      onChange={(e, v) => this.selectHandleChange(e, v, "kala")}
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* بسته‌بندی :</Label>
                    <Autocomplete
                      clearText={"حذف"}
                      closeText={"بستن"}
                      noOptionsText={"در حال دریافت اطلاعات.."}
                      openText={"باز کردن"}
                      className="react-select__control"
                      id="Bastebandy"
                      options={this.state.Bastebandys}
                      groupBy={(option) => option.name}
                      getOptionLabel={(option) => option.name}
                      value={this.state.Bastebandy}
                      onChange={(e, v) =>
                        this.selectHandleChange(e, v, "Bastebandy")
                      }
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>*تعداد ناوگان</Label>
                    <Input
                      value={this.state.freighterNumber}
                      onChange={(e) =>
                        this.setState({
                          freighterNumber:
                            e.target.value.replace(/[^0-9۰-۹]/g, "").length > 3
                              ? 1
                              : e.target.value.replace(/[^0-9۰-۹]/g, ""),
                        })
                      }
                    />
                  </FormGroup>
                </div>
                <div className="d-flex flex-md-row flex-column w-100 justify-content-center flex-wrap">
                  <FormGroup className="w-md-60 w-100 px-1">
                    <Label>توضیحات :</Label>
                    <Input
                      value={this.state.description}
                      type="textarea"
                      onChange={(e) =>
                        this.setState({ description: e.target.value })
                      }
                    />
                  </FormGroup>
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
        <Row className="mb-3">
          <Colxx xxs="12">
            <Card>
              <CardBody className="d-flex flex-column">
                {this.state.errors.length === 0 ? null : (
                  <div>
                    {this.state.errors.map((error, i) => {
                      return (
                        <Alert color="danger" key={i}>
                          {error}
                        </Alert>
                      );
                    })}
                  </div>
                )}

                <div className="d-flex flex-md-row flex-column w-100 justify-content-center mt-4">
                  <Button
                    outline
                    color="primary"
                    className="mx-3 my-md-0 my-1"
                    onClick={() =>
                      this.props.showSweetAlert(
                        "",
                        "آیا از صحت اطلاعات واردشده اطمینان دارید؟",
                        "warning",
                        this.validateInputData,
                      )
                    }
                  >
                    ثبت
                  </Button>

                  <Button
                    outline
                    color="secondary"
                    className="mx-3 my-md-0 my-1"
                    onClick={() =>
                      this.props.showSweetAlert(
                        "",
                        "آیا می‌خواهید تمام اطلاعات واردشده را پاک کنید؟",
                        "danger",
                        this.reset,
                      )
                    }
                  >
                    پاک کردن
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </>
    );
  }
}

export default AddCargo;
